import { render, staticRenderFns } from "./traitement_facture.vue?vue&type=template&id=04980edc&scoped=true&"
import script from "./traitement_facture.vue?vue&type=script&lang=js&"
export * from "./traitement_facture.vue?vue&type=script&lang=js&"
import style0 from "./traitement_facture.vue?vue&type=style&index=0&id=04980edc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04980edc",
  null
  
)

export default component.exports